// extracted by mini-css-extract-plugin
export default {"map-styles_water":"CyprusRegions_map-styles_water__tMgde","region":"CyprusRegions_region__bYZkH","active-region":"CyprusRegions_active-region__dz+k1"};